module.exports = __webpack_public_path__ + "static/media/doctorsectionds.36c8c019.png";